import React, { Component, Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch, useHistory } from 'dva';
import router from 'umi/router';
import Header from 'components/Header/index.js';
import Carousel from 'components/Carousel/index.js';
import Loading from 'components/Loading/index.js';

import Footer from 'components/Footer/index';
import styles from './index.less';

import { getLanguage, getShowTopBar, getValue } from '../../utils/getValue';
import { dateFormat } from 'utils/index.js';
import { PhotoSlider } from 'react-photo-view';
import 'react-photo-view/dist/index.css';

import defaultLayer from 'images/default/layer.jpg';
import iconTime from 'images/icon_time.png';
import iconMap from 'images/icon_map.png';
import iconLocation from 'images/icon_location.png';
import iconNav from 'images/icon_nav.png';
import iconBack from 'images/icon_back.png';
import iconDefaultDevice from 'images/default/lounge.png';
import iconClose from 'images/close.png';

import lgText from '../../config/language';
import getSpecialClassName from '@/utils/special/specialClassName';
import classNames from 'classnames';

const loungeStateText = {
  '-1': '未开发',
  0: '当前满员',
  1: '服务器空闲',
  2: '已经打烊',
};

const showLimitNum = 5; // 展示多少条相关限制航班

export default function Lounge() {
  const history = useHistory();
  const dispatch = useDispatch();

  const [showLoading, setShowLoading] = useState(true);
  const [showLayer, setShowLayer] = useState(false); // 是否展示套餐
  const [selectItem, setSelectItem] = useState<any>({}); // 套餐内容
  const [showPhoto, setShowPhoto] = useState(false); // 展示预览图片
  const [limitPopuName, setLimitPopuName] = useState(''); // 航班限制的名字
  const [limitPopuList, setLimitPopuList] = useState([]); // 展示更多航班限制的列表数据
  const [showMoreLimitPopu, setShowMoreLimitPopu] = useState(false); // 航班限制点击查看更多

  const { code } = (history.location as any).query || {};
  const lg = getLanguage();
  const loungeState = useSelector((state: any) => state.lounge);
  const { loungeMsg } = loungeState;

  const {
    productsImageList,
    loungeStatus,
    productItemList = [],
    lounge = {},
    combosets = [],
    flightInfoLimitList = [], // 相关限制
    specialInfoItemList = [], // 亮点标签
    pointImageList = [], // 路线图
  } = loungeMsg;
  const {
    loungeType,
    name: loungeName,
    terminal,
    inspection,
    businessHours,
    airportName, // 机场名字
    locationGuide, // 位置指引
    bannerList = [], // 导航banner
    hotDishes = [], // 热食
    serviceInstructions, // 服务须知
    tips,
    children,
    ad = '',
    serviceTime,
  } = lounge;

  const gq = localStorage.getItem('gq');
  const showTopBar = getShowTopBar();
  const channel = getValue('channel');
  const dragoncode = getValue('dragoncode');
  const showUseBtn = channel === 'spdb' && !!dragoncode;
  const isRestaurant = loungeType === '4'; // 是否是餐厅
  const showGuidanceBox = pointImageList.length !== 0;
  const {
    OfferInfo,
    ViewDetails,
    HotFood,
    Rule,
    Amenities,
    SetMealOption,
    ServingTime,
    ViewFullMenu,
    CreateUsebtn,
    LimitTitle,
    LightTag,
    Children,
    ExpiredBtn,
    Reminder,
    LimitAirUse,
  } = lgText;

  useEffect(() => {
    dispatch({
      type: 'lounge/queryLoungeDetail',
      payload: {
        code,
        language: lg,
      },
      callback: () => {
        setShowLoading(false);
      },
    });
  }, []);

  const linkTo = (url: any) => {
    window.location.href = url;
  };

  const onShowLayer = (item: any) => {
    document.body.style.overflowY = 'hidden';
    setShowLayer(true);
    setSelectItem(item);
  };

  const onHideLayer = () => {
    document.body.style.overflowY = 'scroll';
    setShowLayer(false);
    setSelectItem({});
  };

  const toUse = () => {
    router.push({
      pathname: '/use',
      query: {
        dragoncode,
        language: lg,
      },
    });
  };

  const limitDom = (name: any, limitAirList: any, isShowAll = false) => {
    // isShowAll 是否展示全部，是的话是点击查看更多后的那个弹窗样式
    const showLimitMore = !isShowAll && limitAirList.length > showLimitNum; // 是否展示更多按钮
    return (
      <div className={styles.limitAirList}>
        <div className={styles.limitItem}>{LimitAirUse}</div>
        {limitAirList.map((el: any, idx: number) => {
          if (!isShowAll && idx > showLimitNum - 1) return null;
          const isLast = !isShowAll && idx === showLimitNum - 1;
          return (
            <div
              key={`limitair_${idx}`}
              className={styles.limitItem}
              style={{ opacity: showLimitMore && isLast ? '0.2' : 1 }}
            >
              {el.name}
            </div>
          );
        })}
        {showLimitMore && (
          <div
            className={styles.limitMore}
            onClick={() => {
              setShowMoreLimitPopu(true);
              setLimitPopuName(name);
              setLimitPopuList(limitAirList);
            }}
          >
            查看更多
          </div>
        )}
      </div>
    );
  };

  const getUseTimeBox = (serviceTime: any) => {
    const { customTime = {} } = serviceTime || {};
    const { specialTime, weekTimeList = [], timeType } = customTime;
    const isWeek = timeType === 'week';
    const isDay = timeType === 'date-time';
    const spceialDom = (
      <React.Fragment>
        <img className={styles.icon} src={iconTime} alt="" />
        <span>{specialTime || businessHours}</span>
      </React.Fragment>
    );
    try {
      if (weekTimeList.length !== 0) {
        return (
          <React.Fragment>
            <img className={styles.icon} src={iconTime} alt="" />
            <div className={styles.weekTimeBox}>
              {weekTimeList.map((el: any, idx: number) => {
                const { startDay, endDay, startTime, endTime } = el;
                let sDay = startDay;
                let eDay = endDay;
                if (isWeek) {
                  sDay = lgText[startDay];
                  eDay = lgText[endDay];
                }
                if (isDay) {
                  sDay = dateFormat('mm-dd', startDay);
                  eDay = dateFormat('mm-dd', endDay);
                }
                return (
                  <div className={styles.item} key={`week_${idx}`}>
                    <span className={styles.timeDesc}>
                      {sDay}-{eDay}
                    </span>
                    <span className={styles.desc}>
                      {startTime}-{endTime}
                    </span>
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        );
      }
      return spceialDom;
    } catch {
      return spceialDom;
    }
  };
  const specialClassName = getSpecialClassName();
  return (
    <Fragment>
      <Header title={loungeName} showTopBar={showTopBar} />

      <Loading loading={showLoading}>
        <div
          className={classNames([styles.mainContent, styles[specialClassName]])}
          style={{ paddingTop: showTopBar ? '1rem' : 0 }}
        >
          <Carousel
            styleClass={{ height: '4.3rem', overflow: 'hidden' }}
            bannerItem={productsImageList}
            autoplay={false}
          />

          <div className={`${styles.message} ${showUseBtn ? styles.hasFooter : ''}`}>
            <div className={styles.messageBox}>
              <div className={styles.lounge}>{loungeName}</div>
              {/* 当前满员 */}
              {loungeStatus && (
                <div className={styles.numTipBox}>
                  <div className={styles.item}>{loungeStatus?.statusName}</div>
                </div>
              )}

              {/* 服务时间 */}
              <div className={styles.useTime}>{getUseTimeBox(serviceTime)}</div>
              {/* 机场 航站楼 */}
              <div className={styles.location}>
                <img className={styles.icon} src={iconMap} alt="" />
                <span>
                  {airportName} {terminal} {inspection}
                </span>
              </div>
              {/* 位置详情 */}
              <div className={styles.location}>
                <img className={styles.icon} src={iconLocation} alt="" />
                <span dangerouslySetInnerHTML={{ __html: locationGuide }} />
              </div>
              {/* 查看路线 */}
              {showGuidanceBox && (
                <div
                  className={styles.lookLocationBox}
                  onClick={() => {
                    setShowPhoto(true);
                  }}
                >
                  <div className={styles.textBox}>
                    <img className={styles.iconNav} src={iconNav} alt="" />
                    <span>查看路线图</span>
                  </div>
                  <img className={styles.iconBack} src={iconBack} alt="" />
                </div>
              )}

              {/* 提示 */}
              {tips && <div className={styles.tipText}>{tips}</div>}
            </div>
            <div className={styles.line} />
            <div className={styles.messageBox}>
              {/* 套餐内容 */}
              {isRestaurant && combosets.length > 0 && (
                <div className={styles.packageBox}>
                  <div className={styles.title}>{SetMealOption}</div>
                  <div className={styles.package}>
                    <div className={styles.packageInner}>
                      {combosets.map((item: any, index: any) => {
                        const { comboDetailList = [] } = item;
                        // 是否展示查看完整菜单   第一项里面的detial大于3 或者comboDetailList套餐的内容大于2
                        const isLenMore = comboDetailList.length > 1;
                        const firstDetail = (comboDetailList[0] || {}).details || {};
                        const isDetailMore = firstDetail.length > 2;
                        const showMore = isLenMore || isDetailMore;
                        return (
                          <div
                            className={styles.item}
                            key={`show_more_${index}`}
                            onClick={() => onShowLayer(item)}
                          >
                            <div className={styles.top}>
                              <img
                                style={{ marginTop: item.imgurl ? '0' : '-0.15rem' }}
                                src={`${item.imgurl || defaultLayer}`}
                                alt=""
                              />
                            </div>
                            <div className={styles.bottom}>
                              <span className={styles.name}>{item.name}</span>
                              <div className={styles.innerTitle1}>{ServingTime}</div>
                              <div className={styles.time}>{item.businesshours}</div>
                              {item.comboDetailList &&
                                item.comboDetailList.map((el1: any, idx1: number) => {
                                  return (
                                    <Fragment key={`comboDetailList_${idx1}`}>
                                      <div className={styles.innerTitle2}>{el1.name}</div>
                                      <div>
                                        {el1.details &&
                                          el1.details.map((el2: any) => {
                                            return (
                                              <div className={styles.content} key={el2.id}>
                                                · {el2.name}
                                              </div>
                                            );
                                          })}
                                      </div>
                                    </Fragment>
                                  );
                                })}
                              {showMore && (
                                <div className={styles.layer}>
                                  <div className={styles.look}>{ViewFullMenu}</div>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
              {/* 相关限制  */}
              {flightInfoLimitList.length !== 0 && (
                <div className={styles.limitBox}>
                  <div className={styles.title}>{LimitTitle}</div>
                  {flightInfoLimitList.map((el: any, idx: number) => {
                    const { limitsName, limitsValue, limitValueJson = [] } = el;
                    const isLimitAir = limitValueJson.length !== 0; // 是否是航班限制
                    return (
                      <div className={styles.limitItemBox} key={`limitItemBox_${idx}`}>
                        <span className={styles.limitTitle}>{limitsName}</span>
                        <div
                          className={styles.limitText}
                          dangerouslySetInnerHTML={{ __html: limitsValue }}
                        />
                        {isLimitAir && limitDom(limitsName, limitValueJson, false)}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* 点亮标签 */}
              {specialInfoItemList.length !== 0 && (
                <div className={styles.lightTagBox}>
                  <div className={styles.title}>{LightTag}</div>
                  <div className={styles.lightTagList}>
                    {specialInfoItemList.map((el: any, idx: number) => {
                      return (
                        <div className={styles.tagItem} key={`tag_${idx}`}>
                          {el}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* 热食 */}
              {hotDishes.length > 0 ? (
                <Fragment>
                  <div className={styles.hotFood}>
                    <div className={styles.title}>{HotFood}</div>
                    <div className={styles.block}>
                      {hotDishes.map((item: any) => {
                        return (
                          <div className={styles.item} key={item.name}>
                            <img
                              src={item.url}
                              alt=""
                              onError={(e: any) => {
                                e.target.onerror = null;
                                e.target.src = iconDefaultDevice;
                              }}
                            />
                            <div className={styles.name}>{item.name}</div>
                            <div className={styles.time}>{item.time}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Fragment>
              ) : null}
              {/* 设施 */}
              {productItemList.length > 0 && (
                <div className={styles.device}>
                  <div className={styles.title}>{Amenities}</div>
                  <div className={styles.deviceInner}>
                    {productItemList.map((item: any, index: number) => {
                      return (
                        <div className={styles.item} key={`product_${index}`}>
                          <img
                            src={item.url}
                            alt=""
                            onError={(e: any) => {
                              e.target.onerror = null;
                              e.target.src = iconDefaultDevice;
                            }}
                          />
                          <div className={styles.name}>{item.name}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {/* 儿童收费标准  */}
              {!!children && (
                <div className={styles.serviceNote}>
                  <div className={styles.title}>{Children}</div>
                  <div
                    className={styles.serviceNoteInner}
                    dangerouslySetInnerHTML={{ __html: children }}
                  ></div>
                </div>
              )}
              {/* 服务须知 */}
              {!!serviceInstructions && (
                <div className={styles.serviceNote}>
                  <div className={styles.title}>{Rule}</div>
                  <div
                    className={styles.serviceNoteInner}
                    dangerouslySetInnerHTML={{ __html: serviceInstructions }}
                  ></div>
                </div>
              )}
              {/* 温馨提示 2/28优化 移除底部温馨提示， 红色框取温馨提示（和红色部分冲突了）*/}
              {/* {tips ? (
                <Fragment>
                  <div className={styles.serviceIntro}>
                    <div className={styles.title}>{Reminder}</div>
                    <div className={styles.serviceIntroInner}>{tips}</div>
                  </div>
                </Fragment>
              ) : null} */}
            </div>
            {bannerList.length > 0 ? (
              <Fragment>
                <div className={styles.youhui}>
                  <div className={styles.title}>{OfferInfo}</div>
                  {bannerList.map((item: any, index: number) => {
                    return (
                      <div
                        className={styles.msg}
                        onClick={() => linkTo(item.url)}
                        key={`banner_${index}`}
                      >
                        <div className={styles.left}>
                          <img src={item.imageUrl} alt="" />
                          <div className={styles.det}>
                            <div className={styles.name}>{item.title}</div>
                            <div className={styles.desc}>{item.descriptionStr}</div>
                          </div>
                        </div>
                        <div className={styles.right}>{ViewDetails}</div>
                      </div>
                    );
                  })}
                </div>
              </Fragment>
            ) : null}
          </div>

          {showUseBtn && (
            <div className={styles.footer}>
              {gq === '0' ? (
                <div className={styles.spdbBtn} onClick={() => toUse()}>
                  {CreateUsebtn}
                </div>
              ) : (
                <div className={styles.expiredBtn}>{ExpiredBtn}</div>
              )}
            </div>
          )}
        </div>
      </Loading>

      {showLayer && (
        <div className={styles.layerWrap}>
          <div className={styles.layerInner}>
            {selectItem.imgurl && (
              <div>
                <img className={styles.layerImg} src={`${selectItem.imgurl}`} alt="" />
              </div>
            )}

            <div className={styles.name}>{selectItem.name}</div>
            {selectItem.comboDetailList && (
              <div className={styles.comlistWrapper}>
                {selectItem.comboDetailList.map((el1: any, idx1: number) => {
                  // 20241225 文彬要求增加availableNum字段，这个效果就是主食后面加个全选之类的文案
                  let titleName = el1.name;
                  if (el1.details && el1.details[0]) {
                    const availableNum = el1.details[0].availableNum;
                    if (availableNum) {
                      titleName += ` (${availableNum})`;
                    }
                  }
                  return (
                    <Fragment key={`comboDetailList_${idx1}`}>
                      <div className={styles.title}>{titleName}</div>
                      <div>
                        {el1.details &&
                          el1.details.map((el2: any, idx2: number) => {
                            return (
                              <div className={styles.content} key={`comboDetailList_li_${idx2}`}>
                                · {el2.name}
                              </div>
                            );
                          })}
                      </div>
                    </Fragment>
                  );
                })}
              </div>
            )}
            <img className={styles.close} src={iconClose} alt="" onClick={() => onHideLayer()} />
            <span className={styles.payerTip}>
              图片仅供参考，实际菜品可能因原材料缺货临时替换成其它菜品
            </span>
          </div>
        </div>
      )}

      {/* 查看更多限制 */}
      {showMoreLimitPopu && (
        <div className={styles.popuWrap}>
          <div className={styles.popuContent}>
            <div className={styles.titleBox}>
              <img
                className={styles.close}
                src={iconClose}
                alt=""
                onClick={() => {
                  setShowMoreLimitPopu(false);
                }}
              />
              <span>{limitPopuName}</span>
            </div>
            {limitDom(limitPopuName, limitPopuList, true)}
          </div>
        </div>
      )}

      {/* 图片预览 */}
      <PhotoSlider
        images={pointImageList.map((item: any) => ({ src: item.url, key: item.url }))}
        visible={showPhoto}
        onClose={() => {
          setShowPhoto(false);
        }}
      />

      <Footer />
    </Fragment>
  );
}
